import React from 'react';

export const YaPago = (data) => {

    const {mdn, topup_amount} = data;

  return (
    <div className='contenedorTicket'>
        <div className='parte1'>
            <div className='iconoExito'></div>
            <div className='tituloTicket'>¡Promoción aplicada!</div>
            
            <div className='cantidadPagada'>${topup_amount}.00</div>
            <p>Activaste y realizaste tu recarga online</p>
        </div>
        <div className='parte2'>

            <div className='contNum'>
                <span className='icoCel'></span>
                <span className='textoIco'>{mdn}</span>
            </div>
           
        </div>
    </div>
  )
}
